module.exports = __webpack_public_path__ + "img/header-img.a72ba6de.png";